/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MANAGER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getVersion",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "increment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "initializeV2",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "0x60a06040523060805234801561001457600080fd5b5061001d610022565b6100d4565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000900460ff16156100725760405163f92ee8a960e01b815260040160405180910390fd5b80546001600160401b03908116146100d15780546001600160401b0319166001600160401b0390811782556040519081527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50565b6080516119396100fd60003960008181610b0d01528181610b360152610cb201526119396000f3fe6080604052600436106101815760003560e01c80638da5cb5b116100d1578063cc8463c81161008a578063d09de08a11610064578063d09de08a1461046f578063d547741f14610484578063d602b9fd146104a4578063ec87621c146104b957600080fd5b8063cc8463c81461040a578063cefc14291461041f578063cf6eefb71461043457600080fd5b80638da5cb5b1461032e57806391d1485414610343578063a1eda53c14610363578063a217fddf14610397578063ad3cb1cc146103ac578063c4d66de8146103ea57600080fd5b80632f2ff15d1161013e57806352d1902d1161011857806352d1902d146102ac578063634e93da146102c1578063649a5ec7146102e157806384ef8ffc1461030157600080fd5b80632f2ff15d1461025957806336568abe146102795780634f1ef2861461029957600080fd5b806301ffc9a714610186578063022d63fb146101bb5780630aa6220b146101e45780630d8e6e2c146101fb578063248a9ca31461021957806329b6eca914610239575b600080fd5b34801561019257600080fd5b506101a66101a13660046115e4565b6104ed565b60405190151581526020015b60405180910390f35b3480156101c757600080fd5b50620697805b60405165ffffffffffff90911681526020016101b2565b3480156101f057600080fd5b506101f96104fe565b005b34801561020757600080fd5b5060025b6040519081526020016101b2565b34801561022557600080fd5b5061020b61023436600461160e565b610514565b34801561024557600080fd5b506101f9610254366004611643565b610536565b34801561026557600080fd5b506101f961027436600461165e565b610646565b34801561028557600080fd5b506101f961029436600461165e565b610672565b6101f96102a73660046116a0565b61073b565b3480156102b857600080fd5b5061020b610756565b3480156102cd57600080fd5b506101f96102dc366004611643565b610773565b3480156102ed57600080fd5b506101f96102fc366004611762565b610787565b34801561030d57600080fd5b5061031661079b565b6040516001600160a01b0390911681526020016101b2565b34801561033a57600080fd5b506103166107b7565b34801561034f57600080fd5b506101a661035e36600461165e565b6107c6565b34801561036f57600080fd5b506103786107fe565b6040805165ffffffffffff9384168152929091166020830152016101b2565b3480156103a357600080fd5b5061020b600081565b3480156103b857600080fd5b506103dd604051806040016040528060058152602001640352e302e360dc1b81525081565b6040516101b291906117ae565b3480156103f657600080fd5b506101f9610405366004611643565b610871565b34801561041657600080fd5b506101cd610933565b34801561042b57600080fd5b506101f96109b1565b34801561044057600080fd5b506104496109f1565b604080516001600160a01b03909316835265ffffffffffff9091166020830152016101b2565b34801561047b57600080fd5b506101f9610a1f565b34801561049057600080fd5b506101f961049f36600461165e565b610a36565b3480156104b057600080fd5b506101f9610a5e565b3480156104c557600080fd5b5061020b7f241ecf16d79d0f8dbfb92cbc07fe17840425976cf0667f022fe9877caa831b0881565b60006104f882610a71565b92915050565b600061050981610a96565b610511610aa0565b50565b60009081526000805160206118c4833981519152602052604090206001015490565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a008054600160401b810460ff16159067ffffffffffffffff1660008115801561057c5750825b905060008267ffffffffffffffff1660011480156105995750303b155b9050811580156105a7575080155b156105c55760405163f92ee8a960e01b815260040160405180910390fd5b845467ffffffffffffffff1916600117855583156105ef57845460ff60401b1916600160401b1785555b6105f886610871565b831561063e57845460ff60401b19168555604051600181527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b505050505050565b8161066457604051631fe1e13d60e11b815260040160405180910390fd5b61066e8282610aad565b5050565b6000805160206118a4833981519152821580156106a7575061069261079b565b6001600160a01b0316826001600160a01b0316145b1561072c576000806106b76109f1565b90925090506001600160a01b0382161515806106d9575065ffffffffffff8116155b806106ec57504265ffffffffffff821610155b15610719576040516319ca5ebb60e01b815265ffffffffffff821660048201526024015b60405180910390fd5b5050805465ffffffffffff60a01b191681555b6107368383610acf565b505050565b610743610b02565b61074c82610ba7565b61066e8282610bea565b6000610760610ca7565b5060008051602061188483398151915290565b600061077e81610a96565b61066e82610cf0565b600061079281610a96565b61066e82610d63565b6000805160206118e4833981519152546001600160a01b031690565b60006107c161079b565b905090565b60009182526000805160206118c4833981519152602090815260408084206001600160a01b0393909316845291905290205460ff1690565b6000805160206118e483398151915254600090600160d01b900465ffffffffffff166000805160206118a4833981519152811580159061084657504265ffffffffffff831610155b61085257600080610868565b6001810154600160a01b900465ffffffffffff16825b92509250509091565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a008054600160401b810460ff16159067ffffffffffffffff166000811580156108b75750825b905060008267ffffffffffffffff1660011480156108d45750303b155b9050811580156108e2575080155b156109005760405163f92ee8a960e01b815260040160405180910390fd5b845467ffffffffffffffff19166001178555831561092a57845460ff60401b1916600160401b1785555b6105f886610dd3565b6000805160206118e4833981519152546000906000805160206118a483398151915290600160d01b900465ffffffffffff16801580159061097b57504265ffffffffffff8216105b610995578154600160d01b900465ffffffffffff166109aa565b6001820154600160a01b900465ffffffffffff165b9250505090565b60006109bb6109f1565b509050336001600160a01b038216146109e957604051636116401160e11b8152336004820152602401610710565b610511610e27565b6000805160206118a4833981519152546001600160a01b03811691600160a01b90910465ffffffffffff1690565b60148054906000610a2f836117f7565b9190505550565b81610a5457604051631fe1e13d60e11b815260040160405180910390fd5b61066e8282610ec4565b6000610a6981610a96565b610511610ee0565b60006001600160e01b031982166318a4c3c360e11b14806104f857506104f882610eeb565b6105118133610f20565b610aab600080610f59565b565b610ab682610514565b610abf81610a96565b610ac98383611034565b50505050565b6001600160a01b0381163314610af85760405163334bd91960e11b815260040160405180910390fd5b61073682826110ab565b306001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161480610b8957507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316610b7d600080516020611884833981519152546001600160a01b031690565b6001600160a01b031614155b15610aab5760405163703e46dd60e11b815260040160405180910390fd5b6000610bb281610a96565b6040516001600160a01b038316907f6b70829fcbe4891157f7a7496f9870927de3c8237adbe9cd39bae09b7382c40990600090a25050565b816001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015610c44575060408051601f3d908101601f19168201909252610c4191810190611810565b60015b610c6c57604051634c9c8ce360e01b81526001600160a01b0383166004820152602401610710565b6000805160206118848339815191528114610c9d57604051632a87526960e21b815260048101829052602401610710565b6107368383611104565b306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610aab5760405163703e46dd60e11b815260040160405180910390fd5b6000610cfa610933565b610d034261115a565b610d0d9190611829565b9050610d198282611191565b60405165ffffffffffff821681526001600160a01b038316907f3377dc44241e779dd06afab5b788a35ca5f3b778836e2990bdb26a2a4b2e5ed69060200160405180910390a25050565b6000610d6e8261121e565b610d774261115a565b610d819190611829565b9050610d8d8282610f59565b6040805165ffffffffffff8085168252831660208201527ff1038c18cf84a56e432fdbfaf746924b7ea511dfe03a6506a0ceba4888788d9b910160405180910390a15050565b610ddb61126d565b6001600160a01b038116610e1457604051631c78150b60e11b81526001600160a01b038216600482015260006024820152604401610710565b610e1f6000826112b6565b6105116112c8565b6000805160206118a4833981519152600080610e416109f1565b91509150610e568165ffffffffffff16151590565b1580610e6a57504265ffffffffffff821610155b15610e92576040516319ca5ebb60e01b815265ffffffffffff82166004820152602401610710565b610ea46000610e9f61079b565b6110ab565b50610eb0600083611034565b505081546001600160d01b03191690915550565b610ecd82610514565b610ed681610a96565b610ac983836110ab565b610aab600080611191565b60006001600160e01b03198216637965db0b60e01b14806104f857506301ffc9a760e01b6001600160e01b03198316146104f8565b610f2a82826107c6565b61066e5760405163e2517d3f60e01b81526001600160a01b038216600482015260248101839052604401610710565b6000805160206118e4833981519152546000805160206118a483398151915290600160d01b900465ffffffffffff168015610ff6574265ffffffffffff82161015610fcc57600182015482546001600160d01b0316600160a01b90910465ffffffffffff16600160d01b02178255610ff6565b6040517f2b1fa2edafe6f7b9e97c1a9e0c3660e645beb2dcaa2d45bdbf9beaf5472e1ec590600090a15b5060010180546001600160a01b0316600160a01b65ffffffffffff948516026001600160d01b031617600160d01b9290931691909102919091179055565b60006000805160206118a48339815191528361109957600061105461079b565b6001600160a01b03161461107b57604051631fe1e13d60e11b815260040160405180910390fd5b6001810180546001600160a01b0319166001600160a01b0385161790555b6110a384846112d0565b949350505050565b60006000805160206118a4833981519152831580156110e257506110cd61079b565b6001600160a01b0316836001600160a01b0316145b156110fa576001810180546001600160a01b03191690555b6110a3848461137c565b61110d826113f8565b6040516001600160a01b038316907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a280511561115257610736828261145d565b61066e6114d3565b600065ffffffffffff82111561118d576040516306dfcc6560e41b81526030600482015260248101839052604401610710565b5090565b6000805160206118a483398151915260006111aa6109f1565b835465ffffffffffff8616600160a01b026001600160d01b03199091166001600160a01b0388161717845591506111ea90508165ffffffffffff16151590565b15610ac9576040517f8886ebfc4259abdbc16601dd8fb5678e54878f47b3c34836cfc51154a960510990600090a150505050565b600080611229610933565b90508065ffffffffffff168365ffffffffffff16116112515761124c8382611848565b611266565b61126665ffffffffffff8416620697806114f2565b9392505050565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a0054600160401b900460ff16610aab57604051631afcd79f60e31b815260040160405180910390fd5b6112be61126d565b61066e8282611502565b610aab61126d565b60006000805160206118c48339815191526112eb84846107c6565b61136b576000848152602082815260408083206001600160a01b03871684529091529020805460ff191660011790556113213390565b6001600160a01b0316836001600160a01b0316857f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a460019150506104f8565b60009150506104f8565b5092915050565b60006000805160206118c483398151915261139784846107c6565b1561136b576000848152602082815260408083206001600160a01b0387168085529252808320805460ff1916905551339287917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a460019150506104f8565b806001600160a01b03163b60000361142e57604051634c9c8ce360e01b81526001600160a01b0382166004820152602401610710565b60008051602061188483398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b6060600080846001600160a01b03168460405161147a9190611867565b600060405180830381855af49150503d80600081146114b5576040519150601f19603f3d011682016040523d82523d6000602084013e6114ba565b606091505b50915091506114ca85838361156b565b95945050505050565b3415610aab5760405163b398979f60e01b815260040160405180910390fd5b6000828218828410028218611266565b61150a61126d565b6000805160206118a48339815191526001600160a01b03821661154357604051636116401160e11b815260006004820152602401610710565b80546001600160d01b0316600160d01b65ffffffffffff851602178155610ac9600083611034565b60608261157b5761124c826115bb565b815115801561159257506001600160a01b0384163b155b1561137557604051639996b31560e01b81526001600160a01b0385166004820152602401610710565b8051156115cb5780518082602001fd5b60405163d6bda27560e01b815260040160405180910390fd5b6000602082840312156115f657600080fd5b81356001600160e01b03198116811461126657600080fd5b60006020828403121561162057600080fd5b5035919050565b80356001600160a01b038116811461163e57600080fd5b919050565b60006020828403121561165557600080fd5b61126682611627565b6000806040838503121561167157600080fd5b8235915061168160208401611627565b90509250929050565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156116b357600080fd5b6116bc83611627565b9150602083013567ffffffffffffffff808211156116d957600080fd5b818501915085601f8301126116ed57600080fd5b8135818111156116ff576116ff61168a565b604051601f8201601f19908116603f011681019083821181831017156117275761172761168a565b8160405282815288602084870101111561174057600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b60006020828403121561177457600080fd5b813565ffffffffffff8116811461126657600080fd5b60005b838110156117a557818101518382015260200161178d565b50506000910152565b60208152600082518060208401526117cd81604085016020870161178a565b601f01601f19169190910160400192915050565b634e487b7160e01b600052601160045260246000fd5b600060018201611809576118096117e1565b5060010190565b60006020828403121561182257600080fd5b5051919050565b65ffffffffffff818116838216019080821115611375576113756117e1565b65ffffffffffff828116828216039080821115611375576113756117e1565b6000825161187981846020870161178a565b919091019291505056fe360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbceef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d869840002dd7bc7dec4dceedda775e58dd541e08a116c6c53815c0bd028192f7b626800eef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d8698401a2646970667358221220f99bbab9741a5c71d2d247853721e3c4edb03e96d81c97ecd890914cb0b5ccf664736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class BaseContractImplV2__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
BaseContractImplV2__factory.bytecode = _bytecode;
BaseContractImplV2__factory.abi = _abi;
//# sourceMappingURL=BaseContractImplV2__factory.js.map